import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// PROJECT DASHBOARD SUMMARY API
// RoleId/UserId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
// results are restricted to the cost centers assigned to this user in UserCostCenters.
// ==============================================

export const getProjectDashboardSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetProjectDashboardSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Project Dashboard Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
